module.exports = __webpack_public_path__ + "img/toko.19ea7eda.svg";